var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "DropdownFilter",
    _vm._g(
      _vm._b(
        {
          staticClass: "multiselect__custom",
          scopedSlots: _vm._u([
            {
              key: "tag",
              fn: function ({ option, remove }) {
                return [
                  _c("MultiselectAvatarTag", {
                    attrs: { option: option, removable: "" },
                    on: { remove: remove },
                  }),
                ]
              },
            },
            {
              key: "singleLabel",
              fn: function ({ option }) {
                return [
                  option
                    ? _c("TableAvatar", {
                        attrs: {
                          image: option.avatar,
                          initial: _vm.getInitials(
                            option.given_name,
                            option.family_name
                          )[0],
                          title: _vm.getFullName(
                            option.given_name,
                            option.family_name
                          ),
                          primary: "",
                        },
                      })
                    : _vm._e(),
                ]
              },
            },
            {
              key: "option",
              fn: function ({ option }) {
                return [
                  _c("MultiselectAvatar", {
                    attrs: { option: option },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "image",
                          fn: function ({ image, defaultClasses }) {
                            return [
                              _c("S3Image", {
                                staticClass: "bg-white",
                                class: defaultClasses,
                                attrs: { s3FileKey: image },
                              }),
                            ]
                          },
                        },
                        {
                          key: "initial",
                          fn: function ({ defaultClasses, initial }) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "avatar",
                                  class: defaultClasses,
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "flex items-center h-full text-sm leading-5",
                                    },
                                    [_vm._v(_vm._s(initial))]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ]
              },
            },
          ]),
        },
        "DropdownFilter",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }